import React from 'react'

import LoadingIndicator from 'components/LoadingIndicator'
import { Snackbar } from 'components/Snackbar'
import { useEnableBodyScroll } from 'hooks/useEnableBodyScroll'

import { useSpDeliveryListController } from './hooks/useSpDeliveryListController'
import { DeliveryListView } from './components/DeliveryListView'

export const SpDeliveryListPage: React.FC = () => {
  useEnableBodyScroll()
  const {
    snackbar,
    tenantName,
    activeTab,
    shipments,
    isLoading,
    deliveryReportUid,
    handleTabChange,
    handleShipmentClick,
    handleNewDelivery,
  } = useSpDeliveryListController()

  return (
    <>
      {isLoading && <LoadingIndicator />}
      <DeliveryListView
        tenantName={tenantName}
        activeTab={activeTab}
        shipments={shipments}
        deliveryReportUid={deliveryReportUid}
        onTabChange={handleTabChange}
        onShipmentClick={handleShipmentClick}
        onNewDelivery={handleNewDelivery}
      />
      <Snackbar {...snackbar} />
    </>
  )
}
